import {Component} from "@angular/core";

@Component({
    selector: "fui-actions",
    styleUrls: ["./actions.component.scss"],
    templateUrl: "./actions.component.html",
    standalone: false
})
export class FUIActionsComponent {
    constructor() {

    }
}
